// extracted by mini-css-extract-plugin
export default {"container":"styles__container___31p1v","avatarWrapper":"styles__avatarWrapper___5xOcH"};